import { Table } from "@counselpro/counselkit";
import { useNavigation, useSubmit } from "react-router-dom";

import { Button } from "@/components/clickable";
import { HStack } from "@/components/layout";
import AuthorizeGate from "@/modules/authorize/gate";
import { isStatementProcessing } from "@/utils/status/statement";
import { useUnprocessedProjectProvider } from "../provider";

import getPath from "@/modules/get-path";
import { isLoading } from "@/utils";

import {
  STATEMETS_TABLE_COLUMNS,
  STATEMETS_TABLE_COLUMNS_WITHOUT_SELECTION,
} from "./columns";

export default function StatementsTable() {
  const { state } = useNavigation();
  const { processStatements, deleteStatements, pooling, isPooling } =
    useUnprocessedProjectProvider();
  const submit = useSubmit();

  const { project, statements } = pooling;

  const onDelete = (rowData) => {
    const ids = rowData.map((item) => item.id);
    const toReload = ids.length === statements.items.length;
    deleteStatements(ids);

    submit(
      { ids, toReload },
      {
        method: "DELETE",
        action: getPath(project, `/statements/delete`),
      },
    );
  };

  const onProcess = (rowData) => {
    const ids = rowData.map((item) => item.id);
    processStatements(ids);
    ids.forEach((id) =>
      submit(
        {},
        {
          method: "PUT",
          action: getPath(project, `/statements/${id}/process`),
        },
      ),
    );
  };

  const isProcessing = (rowData) => {
    return rowData.find((item) => isStatementProcessing(item));
  };

  return (
    <>
      <HStack className="mb-5 mt-10 items-center justify-between">
        <AuthorizeGate>
          <Button color="white" href={`${getPath(project)}/statements/new`}>
            Upload additional statements
          </Button>
        </AuthorizeGate>
      </HStack>

      <Table
        containerClassName="max-h-[650px]"
        loading={isLoading(state)}
        enableFiltering={false}
        rowData={statements.items}
        rowSelection={isPooling ? false : "multiple"}
        selectionActions={[
          {
            label: "Delete",
            onClick: onDelete,
            disabled: isProcessing,
          },
          {
            label: "Process",
            onClick: onProcess,
            disabled: isProcessing,
          },
        ]}
        columnDefs={
          isPooling
            ? STATEMETS_TABLE_COLUMNS_WITHOUT_SELECTION
            : STATEMETS_TABLE_COLUMNS
        }
        suppressRowClickSelection
        domLayout="autoHeight"
      />
    </>
  );
}
